<template>
  <div>
    <DashboardHeader title="Manage ID Cards">
      <v-layout row wrap v-if="isAdmin">
        <v-flex xs12 md2>
          <SelectClassComponent class="mt-4 mx-4" @selected-class="getSelectedClass"></SelectClassComponent>
          <vCardContainer 
          v-if="showCardStatusFilter"
          bgColor="#757575"
          color="white" 
          class="mt-4 mx-4">
            <template #content>
            <vAutoComplete 
            @item-selected="getStudentsForSelectedFilter"
           class="mx-2"
          :items="filters" 
          label="Filter" 
          ></vAutoComplete>
          </template>
          </vCardContainer>
        </v-flex>
        <v-flex xs12 md9 class="mt-4" style="margin:0px">
        
          <v-card v-for="(student,kid) in students" :key="kid+Math.random()+Math.random()">
            
            <div>
              <IDCardFront :student="student"></IDCardFront>
              
            </div>
            <span style="float:right" v-if="getCurrentUser.email == 'adubyte2@yahoo.com'">
              <v-checkbox
                      v-model="cardSwitch"
                      :label="student.sid"
                      @change="updateCardStatus()"
                    ></v-checkbox>
            </span>
            
                    
          </v-card>
        </v-flex>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import studentsjs from "@/plugins/students"
import DashboardHeader from "@/components/DashboardHeader.vue";
import SelectClassComponent from "@/components/GeneralComponents/SelectClassComponent.vue";
import IDCardFront from "@/modules/IDCards/IDCardFront.vue";
import vAutoComplete from '@/components/Legos/vAutoComplete.vue';
import vCardContainer from '@/components/Legos/vCardContainer.vue';

export default {
  components: {
    DashboardHeader,
    SelectClassComponent,
    IDCardFront,
    vAutoComplete,
    vCardContainer
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },

    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    }

  },
  mounted() {
    this.getCardedSIDs()
    this.getAllPhotosSids()
  },
  data: () => ({
    allSIDsForClass:[],
    studentID: null,
    schoolEmis: null,
    classPromotedTo: null,
    datePicker: new Date().toISOString().substr(0, 10),
    reportYear: null,
    filters: [
      {
        text:'Photos Taken But Not Printed',
        value: 'photos-taken'
      },
      {
        text:'Printed And Delivered',
        value: 'printed'
      },
      {
        text:'Photos Not Taken',
        value: 'photos-not-taken'
      },
      {
        text:'Whole Class',
        value: 'all'
      },
      {
        text:'Single Student',
        value: 'single-student'
      },

    ],
    dialog: false,
    feeIDs: [],
    selectedReportTerm: null,

    selectAll: false,
    selectedClass: null,
    selectedTerm: null,
    selectedAdd: "manual",
    selectedFile: null,
    snackbarText: "",
    file64: null,
    snackbarColor: "",
    snackbarModel: false,
    lname: null,
    fname: null,
    grade: null,
    students: [],
    nameRules: [v => !!v || "Field is required"],
    showActionButtons: false,
    search: null,
    selectedStudents: [],
    allSelected: [],
    showCardStatusFilter: false,
    cardedStudentsSids: [],
    allPhotosSids:[]
  }),
  methods: {
    async getCardedSIDs() {
      this.$store.commit('setLoader',true)
      this.cardedStudentsSids = await studentsjs.getCardedStudents()
      this.$store.commit('setLoader',false)
    },
    async getAllPhotosSids() {
      this.$store.commit('setLoader', true)
      this.allPhotosSids = await studentsjs.getAllPhotosSids()
      this.$store.commit('setLoader', false)
    },
    selectAllStudents() {
      if (this.selectAll) {
        this.selectedStudents = [];
        this.students.forEach(student => {
          this.selectedStudents.push(student.sid);
        });
      } else {
        this.selectedStudents = [];
      }
    },

    getSelectedClass(selectedClass) {
      this.students = []
      this.selectedClass = selectedClass;
      this.showCardStatusFilter = true 

      if (selectedClass != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/get-students-by-class",
            { classs: selectedClass },
            this.getAccessToken
          )
          .then(students => {
            
            if (students.length > 0) {
              this.allSIDsForClass = []
              students.forEach(student => {
                this.allSIDsForClass.push(student.sid)
              })
          }
          
            this.selectedStudents = [];
            this.$store.commit("setLoader", false);
          });
      }
    },
    getStudentsForSelectedFilter(filter) {
      switch (filter) {
        case 'photos-taken':
          this.getStudentCardsWithPhotosTakenButNotPrinted()
          break;
      }
    },
    async getStudentCardsWithPhotosTakenButNotPrinted() {
        this.$store.commit("setLoader", true);
        this.students = await studentsjs.getStudentCardsWithPhotosTakenButNotPrinted(this.selectedClass,this.allPhotosSids,this.cardedStudentsSids)
        this.$store.commit("setLoader", false);
      
    },
    updateField(id, column) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "students", id, column, value },
          this.getAccessToken
        )
        
    }
  }
};
</script>

<style>
</style>